import React from 'react'
import { Button } from '@mui/material'
import { NavLink, useLocation } from 'react-router-dom'

function RenderBtn({children, to }) {
     const location = useLocation();

  return (
          <Button
            color="inherit"
            component={NavLink}
            to={to}
            selected={location.pathname === to}
            sx={{
                ':hover': {
                    bgcolor: '#ebebeb ',
                  },
                  '&.active': {
                    bgcolor: '#028DD5',
                    color:'#FFF !important'

                  },
                  width:100,
                borderRadius: '5px',
                opacity: 1,
                color:'#001D2B',
                padding:'10px',
                textTransform:'none',
                fontWeight:600,
                margin:'0 3px'

            }}
            >
            {children}
          </Button>
  )
}

export default RenderBtn